<template>
  <div>
    <b-card class="card-custom" header-tag="header" footer-tag="footer">
      <template v-slot:header>
        <div class="card-title">
          <h3 class="card-label">
            {{ $t("INVOICES") }}
            <i class="mr-2"></i>
            <small class="">{{ $t("LIST") }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <router-link
            v-permission="['stock-actions-show']"
            to="echo-invoice-list"
            class="btn btn-light-success font-weight-bolder mr-2"
            ><i class="flaticon2-document"></i>
            {{ $t("ECHO_INVOICES") }}
          </router-link>
        </div>
      </template>
      <StockInvoiceListTable
        :isPageLoading.sync="isPageLoading"
        :firstLoader.sync="firstLoader"
        :isPreviewMode="false"
      ></StockInvoiceListTable>

      <v-skeleton-loader
        v-if="isPageLoading"
        :loading="isPageLoading"
        type="table"
      ></v-skeleton-loader>
      <v-overlay :value="!firstLoader && isLoadingSharedStore">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <template v-slot:footer></template>
    </b-card>
  </div>
</template>
<style scoped>
tr.previewTr th {
  font-size: 18px !important;
}
</style>
<script>
//General
import StockInvoiceListTable from "@/modules/stock/components/actions/stockList/invoice/StockInvoiceListTable.vue";
import { mapGetters } from "vuex";
//Shared Modules

import { permissionMixin } from "@/core/mixins/permissionMixin.js";

import _ from "lodash";
export default {
  name: "StockInvoiceList",
  mixins: [permissionMixin],
  data() {
    return {
      firstLoader: true,
      isPageLoading: true
    };
  },

  components: {
    StockInvoiceListTable
  },
  computed: {
    ...mapGetters([
      "getItems",
      "isLoadingStock",
      "isLoadingSharedStore",
      "currentUser"
    ])
  }
};
</script>
